import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { RefreshCw, X } from "lucide-react";
import { onStaleWrite } from "@wedding/shared";

const VISIBLE_MS = 9000;

/**
 * Sürümlü belge yazımı reddedildiğinde (409 `stale_write` — kayıt siz düzenlerken başka bir yerden
 * değişti) kullanıcıya ne olduğunu söyler. Olayı `installMutationFetch` yayar; veriyi tazelemek
 * uygulamanın işidir (`onStaleWrite` → `queryClient.invalidateQueries()` + bağlam `refresh()`).
 * Sayfanın kendi "kaydedilemedi" bildirimi de görünür; bu bant NEDENİNİ söyler.
 */
export function StaleWriteNotice() {
  const { t } = useTranslation();
  const [shownAt, setShownAt] = useState<number | null>(null);

  useEffect(() => onStaleWrite(() => setShownAt(Date.now())), []);
  useEffect(() => {
    if (shownAt === null) return;
    const id = window.setTimeout(() => setShownAt(null), VISIBLE_MS);
    return () => window.clearTimeout(id);
  }, [shownAt]);

  if (shownAt === null) return null;
  return createPortal(
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-4 bottom-20 z-[9999] mx-auto flex max-w-lg items-start gap-3 rounded-2xl border border-amber-500/30 bg-card px-4 py-3 shadow-2xl md:bottom-6"
    >
      <RefreshCw className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" aria-hidden="true" />
      <p className="min-w-0 flex-1 text-sm leading-relaxed text-foreground">{t("common.staleWrite")}</p>
      <button
        type="button"
        onClick={() => setShownAt(null)}
        aria-label={t("common.close")}
        className="size-7 shrink-0 cursor-pointer rounded-full text-muted-foreground transition-colors hover:bg-muted flex items-center justify-center"
      >
        <X className="h-4 w-4" />
      </button>
    </div>,
    document.body,
  );
}
